export function redactAnalyticsURL(rawURL: string | undefined, fallbackPathname: string) {
  const fallback = fallbackPathname || '/';
  if (!rawURL) {
    return fallback;
  }

  try {
    const url = new URL(rawURL);
    // Drop query and hash fragments before analytics can capture reset or verification tokens.
    return `${url.origin}${url.pathname}`;
  } catch {
    return rawURL.split(/[?#]/, 1)[0] || fallback;
  }
}
